var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "StockAdjustment" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MovementNumber",
                        error: _vm.$v.form.MovementNumber,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.MovementNumber
                        },
                        model: {
                          value: _vm.form.MovementNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "MovementNumber", $$v)
                          },
                          expression: "form.MovementNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MovementDate",
                        error: _vm.$v.form.MovementDate,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.MovementDate },
                        model: {
                          value: _vm.form.MovementDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "MovementDate", $$v)
                          },
                          expression: "form.MovementDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MovementTime",
                        error: _vm.$v.form.MovementTime,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextTimePicker", {
                        attrs: { disabled: _vm.insertReadonly.MovementTime },
                        model: {
                          value: _vm.form.MovementTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "MovementTime", $$v)
                          },
                          expression: "form.MovementTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "RepresentativeId",
                        error: _vm.$v.form.RepresentativeId,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          url:
                            "VisionNextEmployee/api/Employee/AutoCompleteSearch",
                          searchable: "",
                          orConditionFields: "Code,Description1,Name,Surname",
                          disabled: _vm.insertReadonly.RepresentativeId
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType(
                              "RepresentativeId",
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.selectedRepresentative,
                          callback: function($$v) {
                            _vm.selectedRepresentative = $$v
                          },
                          expression: "selectedRepresentative"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MovementTypeId",
                        error: _vm.$v.form.MovementTypeId,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          url:
                            "VisionNextWarehouse/api/WarehouseMovementType/Search",
                          disabled: _vm.insertReadonly.MovementTypeId
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType(
                              "MovementTypeId",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          disabled: _vm.insertReadonly.StatusId,
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.BranchStockTransfer.Items"),
                    active: ""
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ToWarehouseId",
                            error: _vm.$v.form.ToWarehouseId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextWarehouse/api/Warehouse/AutoCompleteSearch",
                              "dynamic-and-condition": {
                                StatusIds: [1],
                                IsVehicle: 0
                              },
                              disabled: _vm.insertReadonly.ToWarehouseId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "ToWarehouseId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ToStatusId",
                            error: _vm.$v.form.ToStatusId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextStockManagement/api/StockStatus/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "ToStatusId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.ItemCode"
                            ),
                            required: true,
                            error: _vm.$v.stockAdjustmentItems.item,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextItem/api/Item/AutoCompleteSearch",
                              searchable: "",
                              "custom-option": true,
                              "or-condition-fields": "Code,Description1",
                              "dynamic-and-condition": {
                                StatusIds: [1],
                                CardTypeIds: [1, 2, 8]
                              }
                            },
                            on: { input: _vm.selectedItem },
                            model: {
                              value: _vm.stockAdjustmentItems.item,
                              callback: function($$v) {
                                _vm.$set(_vm.stockAdjustmentItems, "item", $$v)
                              },
                              expression: "stockAdjustmentItems.item"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.ToWhStockQuantity"
                            ),
                            required: true,
                            error:
                              _vm.$v.stockAdjustmentItems.toWhStockQuantity,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.stockAdjustmentItems.toWhStockQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.stockAdjustmentItems,
                                  "toWhStockQuantity",
                                  $$v
                                )
                              },
                              expression:
                                "stockAdjustmentItems.toWhStockQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.PlanQuantity"
                            ),
                            required: true,
                            error: _vm.$v.stockAdjustmentItems.quantity,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              min: "1",
                              max: _vm.maxPlanQuantity
                            },
                            on: {
                              keypress: function($event) {
                                return _vm.onlyForCurrencyDot($event)
                              }
                            },
                            model: {
                              value: _vm.stockAdjustmentItems.quantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.stockAdjustmentItems,
                                  "quantity",
                                  $$v
                                )
                              },
                              expression: "stockAdjustmentItems.quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "ml-auto",
                          attrs: { cols: "12", md: "2", lg: "2" }
                        },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addItem()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "2", lg: "2" } },
                        [
                          _c("NextMultipleSelectionStockAdjustment", {
                            attrs: {
                              name: "StockAdjustmentMultipleItem",
                              "hidden-values": _vm.hiddenValues,
                              "dynamic-and-condition": {
                                ToWarehouseStatus: _vm.form.ToStatusId
                                  ? [_vm.form.ToStatusId]
                                  : null,
                                ToWarehouseIds: _vm.form.ToWarehouseId
                                  ? [_vm.form.ToWarehouseId]
                                  : null,
                                FromWarehouseStatus: _vm.form.ToStatusId
                                  ? [_vm.form.ToStatusId]
                                  : null,
                                FromWarehouseIds: _vm.form.ToWarehouseId
                                  ? [_vm.form.ToWarehouseId]
                                  : null,
                                MovementType: [_vm.form.MovementTypeId]
                              },
                              "disabled-button":
                                !_vm.form.ToStatusId ||
                                !_vm.form.ToWarehouseId ||
                                !_vm.form.MovementTypeId,
                              "initial-data": _vm.initialData
                            },
                            model: {
                              value: _vm.form.StockAdjustmentItems,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "StockAdjustmentItems", $$v)
                              },
                              expression: "form.StockAdjustmentItems"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-table-simple",
                            {
                              attrs: { responsive: "", bordered: "", small: "" }
                            },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.ItemCode"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.Items"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.ToWhStockQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.PlanQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("list.operations")))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tbody",
                                _vm._l(_vm.form.StockAdjustmentItems, function(
                                  r,
                                  i
                                ) {
                                  return _c(
                                    "b-tr",
                                    { key: i },
                                    [
                                      _c("b-td", [_vm._v(_vm._s(r.Code))]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(_vm._s(r.Description1))
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(_vm._s(r.ToWhStockQuantity))
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [_vm._v(_vm._s(r.Quantity))]),
                                      _vm._v(" "),
                                      _c(
                                        "b-td",
                                        { staticClass: "text-center" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "btn mr-2 btn-warning btn-sm",
                                              attrs: {
                                                title: _vm.$t("list.edit")
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.editItem(r)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-pencil-alt"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "btn mr-2 btn-danger btn-sm",
                                              attrs: {
                                                title: _vm.$t("list.delete"),
                                                type: "button"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeItem(r)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "far fa-trash-alt ml-1"
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8aa7b6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8aa7b6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/StockAdjustment/insert.vue
// module id = null
// module chunks = 